enum EnvironmentType {
  Dev = 'development',
  Stage = 'pre-production',
  Prod = 'production',
  Local = 'local',
}

enum DeploymentMode {
  Development = 'development',
  Production = 'production',
}

export const NODE_ENV = process.env.NODE_ENV;
export const Environments = process.env.ENVIRONMENT ?? EnvironmentType.Local;
export const IS_DEV_MODE: boolean = NODE_ENV === DeploymentMode.Development;
export const IS_LOCAL_MODE: boolean = Environments === EnvironmentType.Local;

export const PROTOCOL = process.env.PROTOCOL || 'https://';
export const HOST = process.env.HOST;
export const CLIENT_CABINET_HOST = process.env.CLIENT_CABINET_HOST;
export const MAIN_SITE_HOST = process.env.HOST;
export const SERVICES_SITE_HOST = process.env.SERVICES_SITE_HOST;
export const TOP_HOST = IS_LOCAL_MODE ? 'localhost' : process.env.TOP_HOST;

export const SERVER_API_URL = 'http://cabinet:1800';
export const CLIENT_API_URL = `https://${ process.env.LK_SITE_HOST }`;

export const SENTRY_DSN = process.env.SENTRY_DSN;
export const CI_COMMIT_SHORT_SHA = process.env.CI_COMMIT_SHORT_SHA;
export const SENTRY_ORG = process.env.SENTRY_ORG;
export const SENTRY_PROJECT = process.env.SENTRY_PROJECT;
export const SENTRY_URL = process.env.SENTRY_URL;
export const SENTRY_AUTH_TOKEN = process.env.SENTRY_AUTH_TOKEN;

export const DADATA_TOKEN = process.env.DADATA_TOKEN;

export const BROKER_PORT = process.env.BROKER_PORT || 500;
export const BROKER_HOST = process.env.BROKER_HOST || 'localhost';

export const HTTPS_KEY = process.env.HTTPS_KEY;
export const HTTPS_CERT = process.env.HTTPS_CERT;

export const ENV_VARIABLES = {
  NODE_ENV,
  ENVIRONMENT: Environments,
  IS_DEV_MODE,
  IS_LOCAL_MODE,
  SENTRY_DSN,
  CI_COMMIT_SHORT_SHA,
  SENTRY_ORG,
  SENTRY_PROJECT,
  SENTRY_URL,
  SENTRY_AUTH_TOKEN,
  PROTOCOL,
  HOST,
  CLIENT_CABINET_HOST,
  MAIN_SITE_HOST,
  SERVICES_SITE_HOST,
  TOP_HOST,
  DADATA_TOKEN,
  SERVER_API_URL,
  CLIENT_API_URL,
  BROKER_PORT,
  BROKER_HOST,
  HTTPS_KEY,
  HTTPS_CERT,
};
